import { useEffect, useState } from 'react';

interface MasteryTakeawaysProps {
  takeaways: string[];
}

export function MasteryTakeaways({ takeaways }: MasteryTakeawaysProps) {
  const [show, setShow] = useState(false);
  const hasTakeaways = takeaways.length > 0;

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(t);
  }, []);

  if (!hasTakeaways) {
    return null;
  }

  return (
    <section aria-label="What you mastered" className="px-6 pb-16">
      <div className="max-w-3xl mx-auto">
        <h2
          className={`text-2xl md:text-3xl text-foreground mb-8 transition-all duration-600 ease-out ${
            show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          What You Trained
        </h2>

        <ol className="space-y-4">
          {takeaways.map((item, i) => (
            <li
              key={i}
              className={`flex items-start gap-4 transition-all duration-500 ease-out ${
                show ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"
              }`}
              style={{ transitionDelay: `${900 + i * 120}ms` }}
            >
              <span
                className="shrink-0 w-7 h-7 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center mt-0.5"
                aria-hidden="true"
              >
                {i + 1}
              </span>
              <p className="text-foreground/85 leading-relaxed text-base">{item}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
